import { useCapabilitiesStore } from '../stores/capabilitiesStore';
import type { Permission } from './permissions';

// Consults the backend-supplied permission set ONLY.
// No matrix evaluation here — the answer is whatever the server said.
export function usePermission(p: Permission): boolean {
  return useCapabilitiesStore((s) => s.permissionSet.has(p));
}

export function useAnyPermission(...perms: Permission[]): boolean {
  return useCapabilitiesStore((s) => perms.some((p) => s.permissionSet.has(p)));
}

/**
 * True when the account may perform a C2 catalogue action (WP-9).
 *
 * Prefer this over usePermission for gating a control that maps to a guarded route: /me/
 * capabilities reports `permissions` from the ROLE matrix alone, but `actions` is the
 * EFFECTIVE authority — role actions ± per-account overrides. Gating on the role matrix
 * would hide a button from someone individually granted the action, and the route→action
 * map is the same source the server guard consults, so the two cannot drift.
 */
export function useAction(action: string): boolean {
  return useCapabilitiesStore((s) => s.actionSet.has(action));
}
